import { Component } from "react";
import "./style.css";
class Banner extends Component {
  render() {
    return (
      <section id="banner" className="banner__container">
        <div className="container">
          <h1>
            Let's Boost Your Business
            <br /> With The Latest trends and techniques
          </h1>
          <a href="https://calendly.com/razzomediaofficial" className="btn btn-primary" target="_blank">
              Book a Call
            </a>
        </div>
      </section>
    );
  }
}
export default Banner;
